import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const BlogPostCard = ({ post, delay = 0 }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString + 'T00:00:00');
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      whileHover={{ y: -5, transition: { duration: 0.2 } }}
    >
      <Link to={`/blog/${post.slug}`} className="block">
        <div className="group bg-white rounded-3xl p-8 border border-gray-100 hover:border-gray-200 shadow-sm hover:shadow-lg transition-all cursor-pointer h-full">
          {/* Category & Date */}
          <div className="flex items-center gap-3 mb-4">
            <span className="px-3 py-1 bg-gray-50 text-muted-grey text-xs font-medium rounded-full">
              {post.category}
            </span>
            <span className="text-sm text-muted-grey">
              {formatDate(post.date)}
            </span>
          </div>

          {/* Title */}
          <h3 className="text-xl font-bold text-dark-slate mb-3 tracking-tight group-hover:text-dark-navy transition-colors leading-tight">
            {post.title}
          </h3>

          {/* Excerpt */}
          <p className="text-muted-grey leading-relaxed mb-6 text-sm">
            {post.excerpt}
          </p>

          {/* Read More */}
          <div className="opacity-0 group-hover:opacity-100 transition-opacity">
            <span className="text-dark-navy font-medium inline-flex items-center text-sm">
              Read article
              <svg
                className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default BlogPostCard;
